<template>
  <div class="flex1" style="max-width: 1100px;">
    <ImportantData />
    <v-divider />
    <HomeEquityAndRMPaymentsAndFunds />


    <v-divider />
    <div class="mt-8 mb-2">
      <InterestRateScenarioSelector label="Interest rate scenario" />
      <InterestRateScenarioChart />
    </div>
    <div class="mt-8 mb-4">
      <CustomInterestRatesTable />
    </div>
    <v-divider />
    <div class="mt-8 mb-4">
      <CashFlowForCDEscenarios />
    </div>
  </div>
  <!-- <AuditButton v-if="!isResultSaved" /> -->
  <!-- <PreFundRMSense /> -->
</template>

<script>
// import PreFundRMSense from './PreFundRMSense.vue';
import HomeEquityAndRMPaymentsAndFunds from './HomeEquityAndRMPaymentsAndFunds.vue';
import ImportantData from './ImportantData/index.vue';
import InterestRateScenarioChart from '../Charts/InterestRateScenarioChart.vue';
import InterestRateScenarioSelector from '../Selectors/InterestRateScenarioSelector.vue';
import CustomInterestRatesTable from '../Tables/CustomInterestRatesTable.vue';
// import AuditButton from '../AuditButton.vue';
import CashFlowForCDEscenarios from '../Charts/CashFlowForCDEscenarios.vue';

export default {
  components: {
    // PreFundRMSense,
    HomeEquityAndRMPaymentsAndFunds,
    ImportantData,
    CustomInterestRatesTable,
    InterestRateScenarioSelector,
    InterestRateScenarioChart,
    // AuditButton,
    CashFlowForCDEscenarios
  }
};
</script>

<style scoped></style>
